import { api } from "lib/graphql/api"
import { query } from "lib/graphql/query"
import { GET_SCHEDULE } from "routes/schedule/get-schedule"

export const getSchedule = api(async function schedule(id, version = "no_v") {
    return !id ? null : query(GET_SCHEDULE, { code: id, version }, { returns: "schedule", fetchPolicy: "network-only" })
})
